<div [formGroup]="form" *ngIf="offerGroupFilter">
    <!-- Instructions -->
    <div class="d-flex justify-content-between align-items-start gap-2">
        <span [innerHTML]="'variants explanation' | translate"></span>
        <div
            class="badge badge-lg"
            [class.bg-success]="validationResult.isValid"
            [class.bg-warning]="!validationResult.isValid && validationResult.totalCount > 0"
            [class.bg-danger]="validationResult.totalCount === 0 || validationResult.totalCount > 100"
        >
            {{ "variants count" | translate: { count: validationResult.totalCount } }}
        </div>
    </div>
    <div class="d-flex flex-column gap-3 pt-2">
        <app-filter-variant
            [form]="getOfferGroupSelectionsForm()"
            [filter]="offerGroupFilter"
            [platform]="platform"
            *ngIf="hasOfferGroupFilterControl()"
        ></app-filter-variant>

        <!-- Variant Selection for Each Selected Offer Group Value -->
        <div *ngIf="currentSelection.selectedValues.length > 0" class="variant-groups-container">
            <!-- Error Message -->
            <div *ngIf="showErrors && !validationResult.isValid && validationResult.errorMessage" class="text-danger mb-3">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                {{ validationResult.errorMessage | translate: { count: validationResult.totalCount } }}
            </div>

            <!-- Group Cards -->
            <div class="variant-groups" formGroupName="variantSelections">
                <div *ngFor="let groupValue of currentSelection.selectedValues" class="card mb-2">
                    <!-- Group Content (Always Visible) -->
                    <div class="card-body">
                        <!-- Group Title -->
                        <div class="d-flex justify-content-between align-items-center pb-2">
                            <div class="d-flex align-items-center">
                                <h5 class="mb-0">
                                    <strong>{{ offerGroupFilter.displayName }}:</strong>
                                    {{ getGroupLabel(groupValue) }}
                                </h5>
                            </div>
                            <div class="d-flex align-items-center gap-2">
                                <span class="badge bg-light text-dark">
                                    {{ getVariantCountForGroup(groupValue) }} {{ "variants" | translate }}
                                </span>
                            </div>
                        </div>
                        <div *ngIf="otherVariantFilters.length > 0" class="row">
                            <!-- Variant Filter Controls -->
                            <div *ngFor="let variantFilter of otherVariantFilters" class="col-12 col-md-6">
                                <div [formGroup]="getSafeGroupFormControl(groupValue)">
                                    <app-filter-variant
                                        [form]="getSafeGroupFormControl(groupValue)"
                                        [filter]="variantFilter"
                                        [platform]="platform"
                                        *ngIf="hasVariantFilterControl(groupValue, variantFilter.getCode())"
                                    ></app-filter-variant>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
